import { render, staticRenderFns } from "./CatalogTouristInfos.vue?vue&type=template&id=45809c24&"
import script from "./CatalogTouristInfos.vue?vue&type=script&lang=js&"
export * from "./CatalogTouristInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports